import {post} from '../utils/request'
import ca from "element-ui/src/locale/lang/ca";

export default {
    search(keyword) {
        return post("/admin/category/search", {keyword});
    },
    getAll(query, pagination) {
        return post("/admin/category/list", {...query, ...pagination});
    },
    getChildren(catId) {
        return post("/admin/category/getChildren", {catId});
    },
    save(category) {
        return post("/admin/category/create", {...category});
    },
    update(category) {
        return post("/admin/category/update", {...category});
    },
    findById(id) {
        return post("/admin/category/show", {id});
    },
    deleteById(id) {
        return post("/admin/category/delete", {id});
    }
}
